import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "params-section" }
const _hoisted_2 = { class: "params-add-menu" }
const _hoisted_3 = { class: "params-add-menu__list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "field-group params-section__body" }
const _hoisted_6 = {
  key: 0,
  class: "params-row__title"
}
const _hoisted_7 = { class: "params-row__title-text" }
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = { class: "params-row" }
const _hoisted_10 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _component_parameter_expand_modal = _resolveComponent("parameter-expand-modal")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mosta_context_menu, {
      visible: _ctx.addMenuOpen,
      position: _ctx.menuPos,
      "min-width": 240,
      resizable: "",
      "max-width": 420,
      "min-height": 160,
      "menu-class": "params-add-menu-ctx",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:addMenuOpen', false))),
      onContentResize: _ctx.refitAddMenu
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_input, {
            outlined: "",
            dense: "",
            color: "white",
            class: "thin-input",
            modelValue: _ctx.templateSearch,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.templateSearch) = $event)),
            "hide-bottom-space": "",
            clearable: "",
            autofocus: "",
            placeholder: _ctx.$t('search_label'),
            debounce: "200",
            onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateSearch = ''))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "search",
                color: "accent"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTemplates, (tpl) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'tpl_' + tpl.Id,
                class: "params-add-menu__item",
                onClick: ($event: any) => (_ctx.addTemplate(tpl))
              }, _toDisplayString(tpl.Name), 9, _hoisted_4))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "position", "onContentResize"]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instances, (container, pid) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _ctx.containerKey(container),
          class: "params-item"
        }, [
          (_ctx.showRowTitle(container))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(container.Instance?.Name), 1),
                (_ctx.canEdit && _ctx.isRemovable(container))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "params-title-action",
                      title: _ctx.$t('remove'),
                      onClick: ($event: any) => (_ctx.onTitleAction({ action: 'remove' }, container))
                    }, [
                      _createVNode(_component_app_icon, {
                        name: "delete-outline",
                        width: "14px",
                        color: "currentColor",
                        "hover-color": "#D05A4F",
                        cursor: "pointer"
                      })
                    ], 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["params-row__value", {
              'params-row__value--flat': !_ctx.isComplexRow(container),
              'params-row__value--single': _ctx.isSingleValueRow(container),
            }])
            }, [
              _createElementVNode("table", {
                class: "dialog-table",
                ref_for: true,
                ref: 
                (el) => {
                  _ctx.triggerEls[pid] = el;
                }
              
              }, [
                (_ctx.triggerEls[pid])
                  ? (_openBlock(), _createBlock(_component_parameter_inline, {
                      key: 0,
                      "is-root": true,
                      editable: _ctx.canEdit,
                      "is-table": "",
                      id: 'entity-param-' + _ctx.containerKey(container),
                      modelValue: _ctx.parameters_model[pid],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.parameters_model[pid]) = $event),
                      "token-styles": _ctx.tokenStyles,
                      "show-custom": false,
                      "value-set-from-instance": true,
                      "context-trigger": _ctx.triggerEls[pid],
                      "create-mode": false,
                      "show-field-label": _ctx.showFieldLabelFor(container),
                      onTitleAction: ($event: any) => (_ctx.onTitleAction($event, container))
                    }, null, 8, ["editable", "id", "modelValue", "onUpdate:modelValue", "token-styles", "context-trigger", "show-field-label", "onTitleAction"]))
                  : _createCommentVNode("", true)
              ], 512)
            ], 2)
          ])
        ]))
      }), 128))
    ]),
    (_ctx.expandedContainer)
      ? (_openBlock(), _createBlock(_component_parameter_expand_modal, {
          key: 0,
          ref: "expandModal",
          id: 'entity-param-full-' + _ctx.containerKey(_ctx.expandedContainer),
          title: _ctx.expandedTitle,
          editable: _ctx.canEdit,
          "token-styles": _ctx.tokenStyles,
          "show-field-label": _ctx.showFieldLabelFor(_ctx.expandedContainer),
          "model-value": _ctx.parameters_model[_ctx.expandedIndex],
          "onUpdate:modelValue": _ctx.onExpandedModelUpdate
        }, null, 8, ["id", "title", "editable", "token-styles", "show-field-label", "model-value", "onUpdate:modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirmRemoveOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmRemoveOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "delete-outline",
                  width: "18px",
                  color: "#979797"
                }),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("sure_delete")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  flat: "",
                  label: _ctx.$t('cancel'),
                  color: "dark"
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  flat: "",
                  label: _ctx.$t('remove'),
                  autofocus: "",
                  color: "dark",
                  onClick: _ctx.confirmRemove
                }, null, 8, ["label", "onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}